import { ImageProps } from 'next/image';
import { ImageBlock, ImageBlockType } from '../imageBlock/ImageBlock';
import { DefaultBlockProps } from '../switchBlock/SwitchBlock';
import { VideoBlock, VideoBlockType } from '../videoBlock/VideoBlock';
import style from './MediaBlock.module.scss';

export type BlocksMediaType = DefaultBlockProps &
  Pick<ImageProps, 'layout' | 'sizes'> & {
    block_type: 'media';
    loadColor?: string;
  };

// there is ALWAYS an image
// if there is also a video, use the image as a "poster"
export const MediaBlock = (props: BlocksMediaType): JSX.Element | null => {
  // return <p>{props.image}</p>;
  //  no video, display a single image
  if (!props.video) {
    const mobile = props.phone_image
      ? {
          src: props.phone_image,
          width: props.phone_image_width,
          height: props.phone_image_height,
          layout: props.layout,
        }
      : undefined;
    return (
      <ImageBlock
        loadColor={props.loadColor}
        desktop={{
          layout: props.layout,
          src: props.image,
          width: props.image_width,
          height: props.image_height,
          sizes: props.sizes,
        }}
        mobile={mobile}
        alt={props.alt_text}
      />
    );
  }
  // there is a video (and an image), display a video
  if (props.video) {
    // TS being a pain..... can't spread here, it'll loose narrowing
    const videoProps = Object.assign(props);
    return <VideoBlock {...videoProps} />;
  }
  return null;
};
